export const SlackIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="var(--icon-main, #44BEDF)"
        d="M19.71.13a5.38 5.38 0 0 0-5.37 5.39 5.38 5.38 0 0 0 5.37 5.39h5.38V5.52A5.38 5.38 0 0 0 19.7.13m0 14.37H5.38A5.38 5.38 0 0 0 0 19.88a5.38 5.38 0 0 0 5.38 5.4H19.7a5.38 5.38 0 0 0 5.38-5.4 5.38 5.38 0 0 0-5.38-5.38"
      />
      <path
        fill="var(--icon-main, #2EB67D)"
        d="M53.76 19.88a5.38 5.38 0 0 0-5.38-5.38 5.38 5.38 0 0 0-5.37 5.38v5.4h5.37a5.38 5.38 0 0 0 5.38-5.4m-14.34 0V5.52A5.38 5.38 0 0 0 34.05.13a5.38 5.38 0 0 0-5.38 5.39v14.36a5.38 5.38 0 0 0 5.38 5.4 5.38 5.38 0 0 0 5.37-5.4"
      />
      <path
        fill="var(--icon-main, #ECB22E)"
        d="M34.05 54a5.38 5.38 0 0 0 5.37-5.39 5.38 5.38 0 0 0-5.37-5.38h-5.38v5.38A5.38 5.38 0 0 0 34.05 54m0-14.37h14.33a5.38 5.38 0 0 0 5.38-5.38 5.38 5.38 0 0 0-5.38-5.39H34.05a5.38 5.38 0 0 0-5.38 5.39 5.38 5.38 0 0 0 5.38 5.38"
      />
      <path
        fill="var(--icon-main, #E01E5A)"
        d="M0 34.25a5.38 5.38 0 0 0 5.38 5.39 5.38 5.38 0 0 0 5.37-5.4v-5.38H5.38A5.38 5.38 0 0 0 0 34.25m14.34 0V48.6A5.38 5.38 0 0 0 19.7 54a5.38 5.38 0 0 0 5.38-5.39V34.25a5.38 5.38 0 0 0-5.38-5.39 5.38 5.38 0 0 0-5.37 5.39"
      />
    </g>
  </svg>
);
